module.exports = __webpack_public_path__ + "static/media/logo.67240bcc.png";